import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Nav, Tab } from 'react-bootstrap';
import { FaCaretDown } from 'react-icons/fa';
import { CiLocationOn } from 'react-icons/ci';
import { ReactComponent as EmailCheckIcon } from '../../../Assets/images/icons/email-check-icon.svg';
import { ReactComponent as JobTitleIcon } from '../../../Assets/images/icons/job-title-icon.svg';
import { ReactComponent as EmployeesIcon } from '../../../Assets/images/icons/employees-icon.svg';
import { ReactComponent as IndustryIcon } from '../../../Assets/images/icons/industry-icon.svg';
import { ReactComponent as AiFilterIcon } from '../../../Assets/images/icons/ai-filter-icon.svg';
import { getIndustrySuggestionStart, getJobTitleSuggestionStart, getOrgSuggestionStart, getScrapperStart, resetData } from '../../../Store/Slices/scrapperSlice';
import { useDispatch } from 'react-redux';
import CreatableSelect from "react-select/creatable";
import { IoMdPerson } from "react-icons/io";
import CountryStateCitySearch from './countryStateCitySearch';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { formatLabel } from '../../../Components/DateFn';

const animatedComponents = makeAnimated();
const Sidebar = ({ selectedOption, setSelectedOption, setIsShowMatchingContacts, data, totalCount,
    setShowFilterData, setIsInitial, filterObj, setFilterObj, suggestionData, savedData,
    selectedTab, setSelectedtab, totalSavedCount, jobSuggestionData, industrySuggestionData
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    let [responseData, setResponseData] = useState([])
    const didMount = useRef(false);
    let [searchCompany, setSearchCompany] = useState('')
    let [searchResults, setSearchResults] = useState([]);
    let [jobTitleData, setJobTitleData] = useState([]);
    let [industryData, setIndustryData] = useState([]);

    let emailStatusData = [{ value: 'verified', label: 'Verified' }, { value: 'unverified', label: 'Un-Verified' }, { value: 'usermanaged', label: 'User-Managed' }, { value: 'updaterequired', label: 'Update-Required' }, { value: 'unavailable', label: 'Un-Available' }];
    // let jobTitleData = [{ value: 'Manager', label: 'Manager' }, { value: 'Project Manager', label: 'Project Manager' }, { value: 'Teacher', label: 'Teacher' }, { value: 'Owner', label: 'Owner' }, { value: 'Student', label: 'Student' }, { value: 'Director', label: 'Director' }, { value: 'Software Engineer', label: 'Software Engineer' }, { value: 'Consultant', label: 'Consultant' }, { value: 'Account Manager', label: 'Account Manager' }, { value: 'Engineer', label: 'Engineer' }, { value: 'Professor', label: 'Professor' }, { value: 'Sales Manager', label: 'Sales Manager' }, { value: 'Sales', label: 'Sales' }, { value: 'Partner', label: 'Partner' }, { value: 'Associate', label: 'Associate' }, { value: 'President', label: 'President' }, { value: 'Administrative Assistant', label: 'Administrative Assistant' }, { value: 'Supervisor', label: 'Supervisor' }, { value: 'General Manager', label: 'General Manager' }, { value: 'Realtor', label: 'Realtor' }];
    // let industryData = [
    //     {
    //         "label": "Information Technology & Services",
    //         "value": "Information Technology & Services"
    //     },
    //     {
    //         "label": "Construction",
    //         "value": "Construction"
    //     },
    //     {
    //         "label": "Marketing & Advertising",
    //         "value": "Marketing & Advertising"
    //     },
    //     {
    //         "label": "Real Estate",
    //         "value": "Real Estate"
    //     },
    //     {
    //         "label": "health, wellness & Fitness",
    //         "value": "health, wellness & Fitness"
    //     },
    //     {
    //         "label": "Management Consulting",
    //         "value": "Management Consulting"
    //     },
    //     {
    //         "label": "Computer Software",
    //         "value": "Computer Software"
    //     },
    //     {
    //         "label": "Internet",
    //         "value": "Internet"
    //     },
    //     {
    //         "label": "Retail",
    //         "value": "Retail"
    //     },
    //     {
    //         "label": "Financial Services",
    //         "value": "Financial Services"
    //     },
    //     {
    //         "label": "Consumer Services",
    //         "value": "Consumer Services"
    //     },
    //     {
    //         "label": "Hospital & healthcare",
    //         "value": "Hospital & healthcare"
    //     },
    //     {
    //         "label": "Automotive",
    //         "value": "Automotive"
    //     },
    //     {
    //         "label": "Restaurants",
    //         "value": "Restaurants"
    //     },
    //     {
    //         "label": "Education Management",
    //         "value": "Education Management"
    //     },
    //     {
    //         "label": "Food & Beverages",
    //         "value": "Food & Beverages"
    //     },
    //     {
    //         "label": "Design",
    //         "value": "Design"
    //     },
    //     {
    //         "label": "Hospitality",
    //         "value": "Hospitality"
    //     },
    //     {
    //         "label": "Accounting",
    //         "value": "Accounting"
    //     },
    //     {
    //         "label": "Events Services",
    //         "value": "Events Services"
    //     }
    // ]

    let [companyData] = useState([
        {
            "label": "Google",
            "value": "Google",
            "name": "Google",
            "id": "57c4ace7a6da9867ee5599e7",
            "domain": "google.com"
        },
        {
            "label": "Amazon",
            "value": "Amazon",
            "name": "Amazon",
            "id": "5f2a39cb77a7440112460cf5",
            "domain": "amazon.com"
        },
        {
            "label": "LinkedIn",
            "value": "LinkedIn",
            "name": "LinkedIn",
            "id": "5fca408962ba9b00f6d3c961",
            "domain": "linkedin.com"
        },
        {
            "label": "Microsoft",
            "value": "Microsoft",
            "name": "Microsoft",
            "id": "62337760d02af100a5ca2468",
            "domain": "microsoft.com"
        },
        {
            "label": "TED Conferences",
            "value": "TED Conferences",
            "name": "TED Conferences",
            "id": "54a1215e69702d77c2eee302",
            "domain": "ted.com"
        },
        {
            "label": "Y for Yoga",
            "value": "Y for Yoga",
            "name": "Y for Yoga",
            "id": "67270df43ca5f700019c0a08",
            "domain": "yforyoga.online"
        },
        {
            "label": "Unilever",
            "value": "Unilever",
            "name": "Unilever",
            "id": "6131f47c6f7265000138e775",
            "domain": "unilever.com"
        },
        {
            "label": "Deloitte",
            "value": "Deloitte",
            "name": "Deloitte",
            "id": "54a1233869702d8ed4ee5703",
            "domain": "deloitte.com"
        },
        {
            "label": "IBM",
            "value": "IBM",
            "name": "IBM",
            "id": "5d33d0d1a3ae6113e19b1674",
            "domain": "ibm.com"
        },
        {
            "label": "Forbes",
            "value": "Forbes",
            "name": "Forbes",
            "id": "54a1173069702d4926150100",
            "domain": "forbes.com"
        }
    ])

    let employeeCountData = [{ count: "1 - 10", value: "10" }, { count: "11 - 20", value: "20" }, { count: "21 - 50", value: "50" },
    { count: "51 - 100", value: "100" }, { count: "101 - 200", value: "200" }, { count: "201 - 500", value: "500" },
    { count: "501 - 1000", value: "1000" }, { count: "1001 - 2000", value: "2000" }, { count: "2001 - 5000", value: "5000" },
    { count: "5001 - 10000", value: "10000" }, { count: "10000+", value: "10000+" }
    ]


    let [orgData, setOrgData] = useState([])

    useEffect(() => {
        dispatch(getJobTitleSuggestionStart({ search: "", count: 10 }))
        dispatch(getIndustrySuggestionStart({ search: "", count: 10 }))
    }, [])

    useEffect(() => {
        if (jobSuggestionData?.length) {
            setJobTitleData(jobSuggestionData?.map((data) =>
                ({ value: data?.job_title, label: data?.job_title })
            ))
        }
    }, [jobSuggestionData])

    useEffect(() => {
        if (industrySuggestionData?.length) {
            setIndustryData(industrySuggestionData?.map((data) =>
                ({ value: data?.department, label: formatLabel(data?.department) })
            ))
        }
    }, [industrySuggestionData])

    useEffect(() => {
        setOrgData([...companyData]);
    }, [companyData])

    // const [key, setKey] = useState('total');

    // useeffect
    useEffect(() => {
        if (suggestionData?.length) {
            const companyOptions = suggestionData.map(company => ({
                ...company,
                label: company.name,
                value: company.name
            }));
            setSearchResults(companyOptions);
        } else {

        }
    }, [suggestionData])

    const formatTotalCount = (num) => {
        if (num === null || num === undefined) return '';
        if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
        return num.toString();
    }

    const handleEmailStatus = (e) => {
        setIsInitial(true);
        // const isChecked = e.target.checked;
        setFilterObj(prev => ({
            ...prev,
            contact_email_status_v2: e
            // contact_email_status_v2: isChecked ? [...prev.contact_email_status_v2, value]
            //     : prev.contact_email_status_v2.filter(item => item !== value)
        }));
    }

    const handleJobTitle = (e) => {
        setIsInitial(true);
        // const isChecked = e.target.checked;
        setFilterObj(prev => ({
            ...prev,
            person_titles: e
            // person_titles: isChecked ? [...prev.person_titles, value]
            //     : prev.person_titles.filter(item => item !== value)
        }));
    }

    const handleJobTitleInput = (e) => {
        if (e.trim().length === 0) return;
        dispatch(getJobTitleSuggestionStart({ search: e, count: 10 }))
    }

    const handleCompany = (e, value) => {
        setIsInitial(true);
        const isChecked = e.target.checked;
        if (isChecked) {
            const exists = filterObj.organization_ids.some(o => o.id === value.id);
            if (!exists) {
                setFilterObj(prev => ({
                    ...prev,
                    organization_ids: [...prev.organization_ids, value]
                }));
            }
        } else {
            setFilterObj(prev => ({
                ...prev,
                organization_ids: prev.organization_ids.filter(item => item.id !== value.id)
            }));
        }
    }

    const handleIndustry = (e) => {
        setIsInitial(true);
        // const isChecked = e.target.checked;
        setFilterObj(prev => ({
            ...prev,
            keywords: e,
            q_organization_keyword_tags: e
            // keywords: isChecked ? [...prev.keywords, value]
            //     : prev.keywords.filter(item => item !== value)
        }));
    }

    const handleIndustryInput = (e) => {
        if (e.trim().length === 0) return;
        dispatch(getIndustrySuggestionStart({ search: e, count: 10 }))
    }

    const handleLocation = (e) => {
        // debugger
        setIsInitial(true);
        // const valuesArray = e ? e.map(opt => opt.label) : [];
        setFilterObj(prev => ({
            ...prev,
            person_locations: e
            // person_locations: valuesArray
        }));
    }

    // const handleCreate = (inputValue) => {
    //     const newOption = { label: inputValue, value: inputValue.toLowerCase().replace(/\s+/g, "_") };
    //     setOptions((prev) => [...prev, newOption]);
    //     // setSelectedOptions((prev) => [...prev, newOption]);
    // };

    const handleEmployeeCount = (e, value) => {
        setIsInitial(true);
        const isChecked = e.target.checked;
        setFilterObj(prev => ({
            ...prev,
            organization_num_employees_ranges: isChecked ? [...prev.organization_num_employees_ranges, value]
                : prev.organization_num_employees_ranges.filter(item => item !== value)
        }));
    }

    const handleChangeName = (e) => {
        setIsInitial(true);
        setFilterObj(prev => ({
            ...prev,
            q_keywords: e?.target?.value
        }));
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchCompany(value)
        if (value.trim().length === 0) {
            setSearchResults([]);
            return;
        }
    }

    const handleChangeOrg = (selected) => {
        setIsInitial(true);
        // setSelectedOptions(selected || []);
        setFilterObj(prev => ({
            ...prev,
            person_locations: selected || []
        }));
    };

    // const handleCreateOrg = (inputValue) => {
    //     setIsInitial(true);
    //     const newOption = { label: inputValue, value: inputValue.toLowerCase().replace(/\s+/g, "_") };
    //     setOptions((prev) => [...prev, newOption]);
    //     // setSelectedOptions((prev) => [...prev, newOption]);
    //     setFilterObj(prev => ({
    //         ...prev,
    //         person_locations: [...prev.person_locations, newOption]
    //     }));
    // };

    useEffect(() => {
        if (didMount.current) {
            if (searchCompany !== "") {
                let payload = {
                    "organization_domains": searchCompany,
                    "fields": ["name", "domain", "id", "website_url"],
                    "page": 1,
                    "per_page": 10,
                    "organizationId": ""
                }
                dispatch(getOrgSuggestionStart(payload))
            } else {
                setOrgData([...companyData]);
            }
        } else {
            didMount.current = true;
        }
    }, [searchCompany])

    const [options, setOptions] = useState([
        { label: "United States", value: "country1" },
        { label: "America", value: "country2" },
        { label: "North America", value: "country3" },
        { label: "Dallas", value: "country4" },
        { label: "Europe", value: "country5" },
        { label: "Asia", value: "country6" },
        { label: "India", value: "country7" },
        { label: "United Kingdom", value: "country8" },
        { label: "Australia", value: "country9" },
        { label: "Canada", value: "country10" },
        { label: "Germany", value: "country11" },
        { label: "France", value: "country12" },
        { label: "Italy", value: "country13" },
        { label: "Spain", value: "country14" },
        { label: "Brazil", value: "country15" },
        { label: "Mexico", value: "country16" },
        { label: "Japan", value: "country17" },
        { label: "China", value: "country18" },
        { label: "South Korea", value: "country19" },
        { label: "Russia", value: "country20" },
        { label: "South Africa", value: "country21" },
        { label: "Nigeria", value: "country22" },
        { label: "Egypt", value: "country23" },
        { label: "Saudi Arabia", value: "country24" },
        { label: "United Arab Emirates", value: "country25" }
    ])

    const listToRender = searchCompany.trim() === '' ? companyData : searchResults;

    const handleClearAll = () => {
        setIsInitial(true);
        setFilterObj(prev => ({
            ...prev,
            "contact_email_status_v2": [],
            "q_keywords": "",
            "person_titles": [],
            "person_locations": [],
            "organization_ids": [],
            "keywords": [],
            "organization_num_employees_ranges": [],
            "q_organization_keyword_tags": []
        }));
        dispatch(resetData());
    }

    const excludedKeys = [
        'fields',
        'organization_domains',
        'include_similar_titles',
        'name_search'
    ];

    const showClearAll = () => {
        let filledCount = 0;
        let hasArrayWithMultipleValues = false;

        for (const [key, value] of Object.entries(filterObj)) {
            if (excludedKeys.includes(key)) continue;

            if (Array.isArray(value)) {
                if (value.length > 0) filledCount++;
                if (value.length > 1) hasArrayWithMultipleValues = true;
            } else if (value !== "" && value !== null && value !== undefined) {
                filledCount++;
            }
        }

        return filledCount >= 2 || hasArrayWithMultipleValues;
    };

    return (
        <>
            <Tab.Container id="filter-pill-tab" activeKey={selectedTab} >
                <Nav className='mt-2 mx-2 rounded-2 border border-opacity-75 p-1'
                    variant="pills" justify onSelect={(k) => setSelectedtab(k)}>
                    <Nav.Item>
                        <Nav.Link eventKey="total"
                            className={`py-1 px-1 vstack ${selectedTab === 'total' ? 'bg-primary bg-opacity-10 text-primary' : 'text-body'}`}>
                            <span>Total</span><span className='badge bg-light text-body align-self-center fw-normal'>
                                {totalCount ? formatTotalCount(totalCount) : 0}
                            </span>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="saved"
                            className={`py-1 px-1 vstack ${selectedTab === 'saved' ? 'bg-primary bg-opacity-10 text-primary' : 'text-body'}`}>
                            <span>Saved</span><span className='badge bg-light text-body align-self-center fw-normal'>
                                {totalSavedCount ? formatTotalCount(totalSavedCount) : 0}
                            </span>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Tab.Container>
            <ul id='prospectsCollapse'
                className="list-group mt-2 list-group-flush dv-filters setupbox-height overflow-y-auto" style={{ height: 'calc(100vh - 214px)' }}>
                {/* Company */}
                <li className="list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseCompany"
                        aria-expanded="false" aria-controls="collapseCompany">
                        <IndustryIcon width={18} height={18} className="me-1" />
                        <span>Company</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseCompany" data-bs-parent="#prospectsCollapse">
                        <div className="search-box border rounded-2 position-relative mt-2">
                            <button className="searchbutton bg-white" type="button">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <input type="search" placeholder="Search" className="searchfield bg-white" name='companySearch'
                                value={searchCompany} onChange={(e) => handleChange(e)} />
                        </div>
                        <div className="list-group rounded-0 list-group-flush">
                            {/* <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === 'Industry'}
                                    onChange={() => { setSelectedOption('Industry'); setIsShowMatchingContacts(false) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`industry-all`}
                                />
                                <Form.Check.Label className="ps-2 cursor-pointer" htmlFor={`industry-all`}>
                                    <span>All</span>
                                </Form.Check.Label>
                            </Form.Check> */}
                            {listToRender?.map((data, index) => (
                                <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                    <Form.Check.Input
                                        checked={filterObj.organization_ids.some(org => org.id === data.id)}
                                        onChange={(e) => { handleCompany(e, data) }}
                                        className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    />
                                    <Form.Check.Label className="ps-2 cursor-pointer">
                                        <div>{data.name}</div>
                                        <div>{data.domain}</div>
                                    </Form.Check.Label>
                                </Form.Check>
                            ))}
                        </div>
                    </div>
                </li>
                {/* // Company END // */}
                {/* name */}
                <li className="list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseName"
                        aria-expanded="false" aria-controls="collapseName">
                        <IoMdPerson size={18} className="me-1" />
                        <span>Name</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseName" data-bs-parent="#prospectsCollapse">
                        <div className="search-box border rounded-2 position-relative mt-2">
                            <button className="searchbutton bg-white" type="button">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <input type="search" placeholder="Search" className="searchfield bg-white" name='q_keywords'
                                value={filterObj.q_keywords} onChange={(e) => handleChangeName(e)} />
                        </div>
                    </div>
                </li>
                {/* name end */}
                {/* Email Status */}
                <li className="list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseEmailStatus"
                        aria-expanded="false" aria-controls="collapseEmailStatus">
                        <EmailCheckIcon width={18} height={18} className="me-1" />
                        <span>Email Status</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseEmailStatus" data-bs-parent="#prospectsCollapse">
                        <div className="list-group rounded-0">
                            <Select
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                isMulti
                                options={emailStatusData}
                                className="basic-multi-select"
                                onChange={handleEmailStatus}
                                // onCreateOption={handleCreate}
                                value={filterObj.contact_email_status_v2}
                                placeholder="Email Status"
                            />
                            {/* {emailStatusData.map((data) => (
                                <Form.Check key={data.key} type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                    <Form.Check.Input
                                        checked={filterObj.contact_email_status_v2.includes(data.key)}
                                        onChange={(e) => { setSelectedOption(data.key); setIsShowMatchingContacts(true); handleEmailStatus(e, data.key) }}
                                        className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                        id={`emailStatus-${data.key}`}
                                        name="contact_email_status_v2"
                                    />
                                    <Form.Check.Label className="ps-2 cursor-pointer" htmlFor={`emailStatus-${data.key}`}>
                                        <span className={`badge text-body py-2
                                            ${data.value === 'Verified' ? 'bg-success-subtle' : '' ||
                                                data.value === 'Un-Verified' || data.value === 'User-Managed' ? 'bg-warning-subtle' : '' ||
                                                    data.value === 'Un-Available' || data.value === 'Update-Required' ? 'bg-danger-subtle' : ''
                                            }`}>
                                            {data.value}
                                        </span>
                                    </Form.Check.Label>
                                </Form.Check>
                            ))} */}
                        </div>
                    </div>
                </li>
                {/* // Email Status END // */}
                {/* Job Titles END */}
                <li className="list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseJobTitle"
                        aria-expanded="false" aria-controls="collapseJobTitle">
                        <JobTitleIcon width={18} height={18} className="me-1" />
                        <span>Job Titles</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseJobTitle" data-bs-parent="#prospectsCollapse">
                        <ul className="list-group list-group-flush rounded-0 vstack gap-2">
                            <Select
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                isMulti
                                options={jobTitleData}
                                className="basic-multi-select"
                                onChange={handleJobTitle}
                                onInputChange={handleJobTitleInput}
                                // onCreateOption={handleCreate}
                                value={filterObj.person_titles}
                                placeholder="Job Titles"
                            />
                            {/* {jobTitleData?.map((data, index) => (
                                <Form.Check key={data} type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                    <Form.Check.Input
                                        checked={filterObj.person_titles.includes(data)}
                                        onChange={(e) => { handleJobTitle(e, data) }}
                                        className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                        id={`emailStatus-${data}`}
                                        name="person_titles"
                                    />
                                    <Form.Check.Label className="ps-2 cursor-pointer" htmlFor={`emailStatus-${data}`}>
                                        <span className={`badge text-body py-2`}>
                                            {data}
                                        </span>
                                    </Form.Check.Label>
                                </Form.Check>
                            ))} */}
                            {/*<li className='list-group-item px-2 border' onClick={() => handleJobTitle(job)}>
                                     <span>{job}</span>
                                </li> */}
                        </ul>
                    </div>
                </li>
                {/* // Job Titles END // */}
                {/* Locations */}
                <li className="list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseLocations"
                        aria-expanded="false" aria-controls="collapseLocations">
                        <CiLocationOn width={18} height={18} className="me-1" />
                        <span>Locations</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseLocations" data-bs-parent="#prospectsCollapse">
                        <div className="list-group rounded-0 list-group-flush mt-2">
                            <CountryStateCitySearch handleChangeOrg={handleChangeOrg} filterObj={filterObj} setFilterObj={setFilterObj} setIsInitial={setIsInitial} />
                            {/* <Select
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                isMulti
                                options={options}
                                className="basic-multi-select"
                                onChange={handleLocation}
                                value={filterObj.person_locations}
                                placeholder="Locations"
                            /> */}
                        </div>
                    </div>
                </li>
                {/* // Locations END // */}
                {/* #Emploees */}
                <li className="list-group-item text-body px-2 border-top d-none">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseEmployees"
                        aria-expanded="false" aria-controls="collapseEmployees">
                        <EmployeesIcon width={18} height={18} className="me-1" />
                        <span>Employees</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseEmployees" data-bs-parent="#prospectsCollapse">
                        {/* <div className="mt-2">Predefined Range</div> */}
                        <div className="list-group rounded-0 list-group-flush">
                            {employeeCountData?.map((data) => (
                                <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                    <Form.Check.Input
                                        checked={filterObj.organization_num_employees_ranges.includes(data.value)}
                                        onChange={(e) => { handleEmployeeCount(e, data.value) }}
                                        className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    // id={`employees-1-10`}
                                    />
                                    <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer"
                                    //  htmlFor={`employees-1-10`}
                                    >
                                        <span className="flex-fill">{data.count}</span>
                                        {/* <span className='text-secondary ms-auto'>(2.8M)</span> */}
                                    </Form.Check.Label>
                                </Form.Check>
                            ))}
                            {/* <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '11-20'}
                                    onChange={() => { setSelectedOption('11-20'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-11-20`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-11-20`}>
                                    <span className="flex-fill">11 - 20</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '21-50'}
                                    onChange={() => { setSelectedOption('21-50'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-21-50`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-21-50`}>
                                    <span className="flex-fill">21 - 50</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '51-100'}
                                    onChange={() => { setSelectedOption('51-100'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-51-100`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-51-100`}>
                                    <span className="flex-fill">51 - 100</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '101-200'}
                                    onChange={() => { setSelectedOption('101-200'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-101-200`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-101-200`}>
                                    <span className="flex-fill">101 - 200</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '201-500'}
                                    onChange={() => { setSelectedOption('201-500'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-201-500`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-201-500`}>
                                    <span className="flex-fill">201 - 500</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '501-1000'}
                                    onChange={() => { setSelectedOption('501-1000'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-501-1000`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-501-1000`}>
                                    <span className="flex-fill">501 - 1000</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '1001-2000'}
                                    onChange={() => { setSelectedOption('1001-2000'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-1001-2000`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-1001-2000`}>
                                    <span className="flex-fill">1001 - 2000</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '2001-5000'}
                                    onChange={() => { setSelectedOption('2001-5000'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-2001-5000`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-2001-5000`}>
                                    <span className="flex-fill">2001 - 5000</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '5001-10000'}
                                    onChange={() => { setSelectedOption('5001-10000'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-5001-10000`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-5001-10000`}>
                                    <span className="flex-fill">5001 - 10000</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check>
                            <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === '10000+'}
                                    onChange={() => { setSelectedOption('10000+'); setIsShowMatchingContacts(true) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`employees-10000+`}
                                />
                                <Form.Check.Label className="hstack w-100 ps-2 cursor-pointer" htmlFor={`employees-10000+`}>
                                    <span className="flex-fill">10000+</span>
                                    <span className='text-secondary ms-auto'>(2.8M)</span>
                                </Form.Check.Label>
                            </Form.Check> */}
                        </div>
                    </div>
                </li>
                {/* // #Emploees END // */}
                {/* Industry & Keywords */}
                <li className="list-group-item text-body px-2 border-top border-bottom">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseIndustry"
                        aria-expanded="false" aria-controls="collapseIndustry">
                        <IndustryIcon width={18} height={18} className="me-1" />
                        <span>Departments</span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseIndustry" data-bs-parent="#prospectsCollapse">
                        {/* <div className="search-box border rounded-2 position-relative mt-2">
                            <button className="searchbutton bg-white" type="button">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <input type="search" placeholder="Search" className="searchfield bg-white" name='industrySearch' />
                        </div> */}
                        <div className="list-group rounded-0 list-group-flush">
                            {/* <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                <Form.Check.Input
                                    checked={selectedOption === 'Industry'}
                                    onChange={() => { setSelectedOption('Industry'); setIsShowMatchingContacts(false) }}
                                    className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    id={`industry-all`}
                                />
                                <Form.Check.Label className="ps-2 cursor-pointer"
                                    htmlFor={`industry-all`}
                                >
                                    <span>All</span>
                                </Form.Check.Label>
                            </Form.Check> */}
                            {/* {industryData?.map((data, index) => (
                                <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                                    <Form.Check.Input
                                        checked={filterObj.keywords.includes(data)}
                                        onChange={(e) => { handleIndustry(e, data) }}
                                        className="fs-5 my-auto border-secondary-subtle cursor-pointer"
                                    />
                                    <Form.Check.Label className="ps-2 cursor-pointer">
                                        <span>{data}</span>
                                    </Form.Check.Label>
                                </Form.Check>
                            ))} */}
                            {/* <Select
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                isMulti
                                options={industryData}
                                className="basic-multi-select"
                                onChange={handleIndustry}
                                value={filterObj.keywords}
                                placeholder="Industry & Keywords"
                            /> */}
                            <Select
                                components={animatedComponents}
                                closeMenuOnSelect={false}
                                isMulti
                                options={industryData}
                                className="basic-multi-select"
                                onChange={handleIndustry}
                                onInputChange={handleIndustryInput}
                                // onCreateOption={handleCreate}
                                // value={filterObj.keywords}
                                value={filterObj?.q_organization_keyword_tags}
                                placeholder="Departments"
                            />
                        </div>
                    </div>
                </li>
                {/* // Industry & Keywords END // */}
                {/* AI not for now */}
                {/* AI Filters */}
                <li className="d-none list-group-item text-body px-2 border-top">
                    <button type="button"
                        className="btn btn-link text-decoration-none text-body p-0 hstack w-100 text-start"
                        data-bs-toggle="collapse" data-bs-target="#collapseAiFilter"
                        aria-expanded="false" aria-controls="collapseAiFilter">
                        <AiFilterIcon width={18} height={18} className="me-1" />
                        <span className='flex-fill hstack'>
                            <span>AI Filters</span>
                            <span className='text-bg-success ms-auto me-2 px-2'>New!</span>
                        </span>
                        <FaCaretDown size={13} className="collapse-arrow ms-auto" />
                    </button>
                    <div className="collapse pt-2" id="collapseAiFilter" data-bs-parent="#prospectsCollapse">
                        <div className="mt-2">AI Filter</div>
                    </div>
                </li>
                {/* // AI Filters END // */}
                {/* reset filters */}
                {/* {data && ( */}
                {showClearAll() && (
                    <li className="list-group-item text-body px-2 mt-auto d-flex align-items-center justify-content-center">
                        <button type="button" class="btn btn-outline-primary btn-blue rounded-2 me-1 curor-pointer"
                            onClick={() => handleClearAll()}>Reset Filters</button>
                    </li>
                )}
            </ul>
        </>
    )
}
export default Sidebar;